import { render, staticRenderFns } from "./multipleSelect-editor.vue?vue&type=template&id=12fab021&scoped=true"
import script from "./multipleSelect-editor.vue?vue&type=script&lang=js"
export * from "./multipleSelect-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fab021",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12fab021')) {
      api.createRecord('12fab021', component.options)
    } else {
      api.reload('12fab021', component.options)
    }
    module.hot.accept("./multipleSelect-editor.vue?vue&type=template&id=12fab021&scoped=true", function () {
      api.rerender('12fab021', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/multipleSelect-editor.vue"
export default component.exports